import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import Editor from '@monaco-editor/react';
import { toast } from 'react-toastify';

import {
  Box,
  Button,
  Divider,
  Modal, 
  Typography
} from '@mui/material';

import useSelectedCompany from '../../../../../components/hooks/useSelectedCompany';
import LoadingButton from '../../../../../components/buttons/Button';

import { 
  UpdateCompanyConfigBIZcore 
} from '../../../../../redux/actions/business/core/companyConfigActions';

import style from "../../../../../global.scss";

const CompanyConfigModal = ({
  open, 
  setOpen,
  title,
  update,
  handleGet
}) => {
  const dispatch = useDispatch();
  const companyId = useSelectedCompany();
  const [mode, setMode] = useState(-1);
  const [formData, setFormData] = useState("");
  const [loading, setLoading] = useState(false);
  const editorRef = useRef(null);

  const handleClose = () => {
    setOpen(false);
    setMode(-1);
    setFormData("");
  };

  function handleEditorDidMount(editor, monaco) {
    editorRef.current = editor;
    // Auto-format when editor first loads
    editor.getAction('editor.action.formatDocument').run();
  };

  useEffect(() => {
    try {
      if(open){
        console.log(update.json)
        if(update.defaultMode === 1){
          // mode = 1 - create company config
          setMode(1);
        }else if(update.defaultMode === 2){
          // mode = 2 - edit company config
          setMode(2);
          setFormData(update.json);
        }else{
          toast.error("Invalid modal");
          handleClose();
        }
      }
    } catch (err) {
      console.log(err);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleSubmit = () => {
    try {
      if (mode === 1) {
        // mode = 1 - create new system config
        
      } else if (mode === 2){
        // mode = 2 - edit system config
        let obj = {
          "json": formData
        };
        dispatch(UpdateCompanyConfigBIZcore(companyId, update?.id, obj, setLoading)).then(() => {
          handleGet((setLoading)).then(() => {
            handleClose();
          })
        });
      } else {

      };
    } catch (err) {}
  };


  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="flexCenterCenterRow"
        width={"100vw"} height={"100vh"}>
        <Box maxWidth={"md"} className="modal">
          <Box width={"100%"}
            sx={{ margin: "15px 15px 30px 15px"}}>
            <Typography variant='h6' sx={{ color: style["primary"] }}>
              {title}
            </Typography>
          </Box>
          {
            open
            &&
            <Editor height="80vh" 
              language={"json"}
              value={formData || "//no content provided"} 
              onChange={(e) => setFormData(e)}
              theme='vs-dark'
              options={{
                wordWrap: true,
                formatOnPaste: true,
                formatOnType: true,
                scrollBeyondLastLine: false,
              }}
              onMount={handleEditorDidMount}
              />
          }
          <Divider
            sx={{ backgroundColor: "rgba(44, 45, 47, 1)" }}/>
          <Box className="flexCenterFERow" sx={{ gap: "20px", margin: "15px"}}>
            <Button variant='outlined'
              onClick={handleClose}>
              Close
            </Button>
            <LoadingButton 
              variant='outlined'
              loading={loading}
              onClick={handleSubmit}>
              Submit
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default CompanyConfigModal;